import {getCookie} from "../../services/cookie";
import * as actionTypes from "./actionTypes";
import * as config from "../../config";
import {logout} from "./authenticationActions";


export const getModuleRankingClasses = () => {
    return (dispatch) => {
        dispatch({type: actionTypes.GET_CLASSES_REQUEST});

        fetch(config.MODULE_RANKING_CLASSES_URL, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                xAuthLuxotticaToken: getCookie("xAuthLuxotticaToken"),
            },
        })
            .then((response) => {
                if (response.status === 401) {
                    dispatch(logout());
                }
                return response.json();
            })
            .then((data) => {
                const classesArray = data && data.content ? data.content : data;
                if (classesArray && Array.isArray(classesArray)) {
                    const mappedClasses = classesArray
                        .map((item) => {
                            if (typeof item === 'object') {
                                return {
                                    value: item.classId,
                                    label: `${item.brandCode} - ${item.commodityDescription}`
                                };
                            }
                            return {value: item, label: item};
                        })
                        .sort((a, b) => a.label.localeCompare(b.label));

                    dispatch({
                        type: actionTypes.GET_CLASSES_SUCCESS,
                        payload: mappedClasses,
                    });
                } else {
                    dispatch({type: actionTypes.GET_CLASSES_FAILURE});
                }
            })
            .catch((err) => {
                console.error("Error fetching classes:", err);
                dispatch({type: actionTypes.GET_CLASSES_FAILURE});
            });
    };
};

const buildModuleRankingUrl = (classId, pageIndex, pageSize, search, showNewModules) => {
    const searchTerms = [];
    if (classId) {
        searchTerms.push(`classId=${classId}`);
    }
    if (search) {
        searchTerms.push(`search=${search}`);
    }
    if (showNewModules) {
        searchTerms.push(`newModules=${showNewModules}`);
    }

    const queryParams = new URLSearchParams({
        pageNumber: pageIndex,
        pageSize: pageSize,
    });

    const searchParamString = searchTerms.join(',');
    if (searchParamString) {
        queryParams.append("q", searchParamString);
    }

    return `${config.MODULE_RANKING_URL}?${queryParams.toString()}`;
};

export const getModuleRankingPage = (classId, pageIndex, pageSize, search, showNewModules) => {
    return (dispatch) => {
        const requestUrl = buildModuleRankingUrl(classId, pageIndex, pageSize, search, showNewModules);

        return fetch(requestUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                xAuthLuxotticaToken: getCookie("xAuthLuxotticaToken"),
            },
        })
            .then((response) => {
                if (response.status === 401) {
                    dispatch(logout());
                }
                return response.json();
            })
            .then((data) => ({
                modules: data?.content || [],
                totalCount: data?.total_result || 0,
            }));
    };
};

export const getModuleRanking = (classId, pageIndex, pageSize, search, showNewModules) => {
    return (dispatch) => {
        dispatch({type: actionTypes.GET_MODULE_RANKING_REQUEST});

        return dispatch(getModuleRankingPage(classId, pageIndex, pageSize, search, showNewModules))
            .then((data) => {
                if (data) {
                    dispatch({
                        type: actionTypes.GET_MODULE_RANKING_SUCCESS,
                        payload: {
                            modules: data.modules,
                            totalCount: data.totalCount,
                        },
                    });
                } else {
                    dispatch({type: actionTypes.GET_MODULE_RANKING_FAILURE});
                }
            })
            .catch((err) => {
                console.error("Error fetching modules:", err);
                dispatch({type: actionTypes.GET_MODULE_RANKING_FAILURE});
            });
    };
};

export const saveModuleRankingOrder = (classId, positionChanges, pageIndex, pageSize, search, showNewModules, fromMonth) => {
    return (dispatch) => {
        dispatch({type: actionTypes.SAVE_MODULE_RANKING_REQUEST});

        const body = {
            classId,
            monthId: fromMonth,
            rankingChanges: Object.entries(positionChanges).map(([moduleName, newRanking]) => ({
                moduleName,
                rankingPosition: newRanking,
            })),
        };

        fetch(config.MODULE_RANKING_SAVE_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                xAuthLuxotticaToken: getCookie("xAuthLuxotticaToken"),
            },
            body: JSON.stringify(body),
        })
            .then((response) => {
                if (response.status === 401) {
                    dispatch(logout());
                }
                return response.json();
            })
            .then((data) => {
                dispatch({type: actionTypes.SAVE_MODULE_RANKING_SUCCESS, payload: data});
                // Re-fetch after save
                dispatch(getModuleRanking(classId, pageIndex, pageSize, search, showNewModules));
            })
            .catch((err) => {
                console.error("Error saving ranking:", err);
                dispatch({type: actionTypes.SAVE_MODULE_RANKING_FAILURE});
            });
    };
};

export const clearSaveModuleRankingResponse = () => {
    return (dispatch) => {
        dispatch({type: actionTypes.CLEAR_SAVE_MODULE_RANKING_RESPONSE});
    };
};

export const lockModuleRanking = (classId) => {
    return (dispatch) => {
        dispatch({type: actionTypes.LOCK_MODULE_RANKING_REQUEST});

        return fetch(config.MODULE_RANKING_LOCK_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                xAuthLuxotticaToken: getCookie("xAuthLuxotticaToken"),
            },
            body: JSON.stringify({classId}),
        })
            .then((response) => {
                if (response.ok) {
                    dispatch({type: actionTypes.LOCK_MODULE_RANKING_SUCCESS});
                    return response;
                } else {
                    dispatch({type: actionTypes.LOCK_MODULE_RANKING_FAILURE});
                    throw new Error("Lock failed");
                }
            })
            .catch((err) => {
                console.error("Error locking ranking:", err);
                dispatch({type: actionTypes.LOCK_MODULE_RANKING_FAILURE});
                throw err;
            });
    };
};

export const getModuleRankingByNames = (moduleNames) => {
    return (dispatch) => {
        const queryParams = new URLSearchParams({
            pageNumber: 0,
            pageSize: moduleNames.length,
        });
        queryParams.append("q", `moduleName=in=${moduleNames.join('|')}`);

        return fetch(`${config.MODULE_RANKING_URL}?${queryParams.toString()}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                xAuthLuxotticaToken: getCookie("xAuthLuxotticaToken"),
            },
        })
            .then((response) => {
                if (response.status === 401) {
                    dispatch(logout());
                }
                return response.json();
            })
            .then((data) => (data ? (data.content || []) : []))
            .catch((err) => {
                console.error("Error fetching module rankings by labels:", err);
                return [];
            });
    };
};

export const getModuleRankingMonths = (classId) => {
    return (dispatch) => {
        const url = config.MODULE_RANKING_MONTHS_URL.replace('{0}', classId);
        return fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                xAuthLuxotticaToken: getCookie("xAuthLuxotticaToken"),
            },
        })
            .then((response) => {
                if (response.status === 401) {
                    dispatch(logout());
                }
                return response.json();
            })
            .then((data) => Array.isArray(data) ? data : (data?.content || []))
            .catch((err) => {
                console.error("Error fetching months by class:", err);
                return [];
            });
    };
};

export const getModuleRankingLock = (classId) => {
    return (dispatch) => {
        dispatch({type: actionTypes.GET_MODULE_RANKING_LOCK_REQUEST});

        return fetch(`${config.MODULE_RANKING_LOCK_URL}?classId=${classId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                xAuthLuxotticaToken: getCookie("xAuthLuxotticaToken"),
            },
        })
            .then((response) => {
                if (response.status === 401) {
                    dispatch(logout());
                }
                return response.json();
            })
            .then((data) => {
                dispatch({
                    type: actionTypes.GET_MODULE_RANKING_LOCK_SUCCESS,
                    payload: {userLock: data?.userLock || null, tsLock: data?.tsLock || null},
                });
                return data;
            })
            .catch((err) => {
                console.error("Error fetching lock status:", err);
                dispatch({type: actionTypes.GET_MODULE_RANKING_LOCK_FAILURE});
            });
    };
};

export const unlockModuleRanking = (classId) => {
    return (dispatch) => {
        dispatch({type: actionTypes.UNLOCK_MODULE_RANKING_REQUEST});

        return fetch(config.MODULE_RANKING_UNLOCK_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                xAuthLuxotticaToken: getCookie("xAuthLuxotticaToken"),
            },
            body: JSON.stringify({classId}),
        })
            .then((response) => {
                if (response.ok) {
                    dispatch({type: actionTypes.UNLOCK_MODULE_RANKING_SUCCESS});
                    return response;
                } else {
                    dispatch({type: actionTypes.UNLOCK_MODULE_RANKING_FAILURE});
                    throw new Error("Lock failed");
                }
            })
            .catch((err) => {
                console.error("Error locking ranking:", err);
                dispatch({type: actionTypes.UNLOCK_MODULE_RANKING_FAILURE});
                throw err;
            });
    };
};

